module.exports = __webpack_public_path__ + "static/media/spider-web.980fa7d4.svg";